// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>7</span>&nbsp;&nbsp;You have put gladness in my heart,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;more than when their corn and wine and oil increase.<br> </p> </div></div>";
// Exports
module.exports = code;